(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('pieSections', pieSections);

    /* @ngInject */
    function pieSections() {
        var directive = {
            bindToController: true,
            templateUrl: 'pie-sections.tpl',
            controller: pieSectionsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    /* @ngInject */
    function pieSectionsController ($scope) {
        $scope.vm.pieSections = [
            {
                "type": "has-single-content",
                "center": true,
                "title": "! 1 COLUMN",
                "description": "Phasellus fermentum, ipsum quis sollicitudin ultricies, enim lacus molestie diam, a dignissim orci nibh in mauris. Suspendisse tincidunt, mi vel mattis egestas, ante velit finibus velit, id congue ipsum purus nec quam. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In vitae accumsan nibh. Aenean vestibulum euismod eleifend. Phasellus id turpis sem. Vivamus fermentum ex eget enim consequat placerat. Phasellus vitae aliquam ipsum, id aliquam justo. Suspendisse id eros vulputate tellus ultricies condimentum at rhoncus sapien. Nulla in lobortis velit, vel congue ex.",
                "cta": true,
                "cta-text": "cta",
                "cta-link": "#"
            },
            {
                "type": "has-image-header",
                "title": "! TA-TE-IM",
                "description": "Suspendisse consectetur, purus id suscipit pharetra, nunc erat tincidunt felis, quis rutrum felis nunc in orci. Donec ut tempus est, id dignissim augue. Maecenas aliquam mauris sodales massa elementum volutpat. Donec lacus turpis, faucibus id dolor sed, rutrum dapibus metus. Phasellus ullamcorper, libero non vulputate pretium, elit nisi imperdiet ante, nec dapibus leo magna a erat. In hac habitasse platea dictumst. Praesent convallis lacus a dolor interdum, eu varius mauris rhoncus.",
                "text-position": "left",
                "cta": true,
                "divider": true,
                "cta-text": "GO",
                "cta-link": "#",
                "img-link": "http://servings.dev.limusdesign.com/wp-content/uploads/2017/02/food-q-c-640-480-5.jpg",
                "img-alt": "alt-text"
            },
            {
                "type": "has-image",
                "title": "! Te + im",
                "description": "Suspendisse consectetur, purus id suscipit pharetra, nunc erat tincidunt felis, quis rutrum felis nunc in orci. Donec ut tempus est, id dignissim augue. Maecenas aliquam mauris sodales massa elementum volutpat. Donec lacus turpis, faucibus id dolor sed, rutrum dapibus metus. Phasellus ullamcorper, libero non vulputate pretium, elit nisi imperdiet ante, nec dapibus leo magna a erat. In hac habitasse platea dictumst. Praesent convallis lacus a dolor interdum, eu varius mauris rhoncus.",
                "text-position": "right",
                "cta": false,
                "divider": false,
                "img-link": "http://servings.dev.limusdesign.com/wp-content/uploads/2017/02/food-q-c-640-480-5.jpg",
                "img-alt": "alt-text"
            },
            {
                "type": "has-double-content",
                "title": "! 2 COLUMNS",
                "columns": [
                    {
                        "description": "Suspendisse consectetur, purus id suscipit pharetra, nunc erat tincidunt felis, quis rutrum felis nunc in orci. Donec ut tempus est, id dignissim augue. Maecenas aliquam mauris sodales massa elementum volutpat. Donec lacus turpis, faucibus id dolor sed, rutrum dapibus metus. Phasellus ullamcorper, libero non vulputate pretium, elit nisi imperdiet ante, nec dapibus leo magna a erat. In hac habitasse platea dictumst. Praesent convallis lacus a dolor interdum, eu varius mauris rhoncus."
                    },
                    {
                        "description": "Suspendisse consectetur, purus id suscipit pharetra, nunc erat tincidunt felis, quis rutrum felis nunc in orci. Donec ut tempus est, id dignissim augue. Maecenas aliquam mauris sodales massa elementum volutpat. Donec lacus turpis, faucibus id dolor sed, rutrum dapibus metus. Phasellus ullamcorper, libero non vulputate pretium, elit nisi imperdiet ante, nec dapibus leo magna a erat. In hac habitasse platea dictumst. Praesent convallis lacus a dolor interdum, eu varius mauris rhoncus."
                    }
                ],
                "cta": false,
                "divider": false
            },
            {
                "type": "has-multicolumns",
                "title": "! multicolumn list",
                "columns": [
                    {
                        "description": "Suspendisse consectetur, purus id suscipit pharetra, nunc erat tincidunt felis, quis rutrum felis nunc in orci. Donec ut tempus est, id dignissim augue. Maecenas aliquam mauris sodales massa elementum volutpat. Donec lacus turpis, faucibus id dolor sed, rutrum dapibus metus. Phasellus ullamcorper, libero non vulputate pretium, elit nisi imperdiet ante, nec dapibus leo magna a erat. In hac habitasse platea dictumst. Praesent convallis lacus a dolor interdum, eu varius mauris rhoncus."
                    },
                    {
                        "description": "Suspendisse consectetur, purus id suscipit pharetra, nunc erat tincidunt felis, quis rutrum felis nunc in orci. Donec ut tempus est, id dignissim augue. Maecenas aliquam mauris sodales massa elementum volutpat. Donec lacus turpis, faucibus id dolor sed, rutrum dapibus metus. Phasellus ullamcorper, libero non vulputate pretium, elit nisi imperdiet ante, nec dapibus leo magna a erat. In hac habitasse platea dictumst. Praesent convallis lacus a dolor interdum, eu varius mauris rhoncus."
                    },
                    {
                        "description": "Suspendisse consectetur, purus id suscipit pharetra, nunc erat tincidunt felis, quis rutrum felis nunc in orci. Donec ut tempus est, id dignissim augue. Maecenas aliquam mauris sodales massa elementum volutpat. Donec lacus turpis, faucibus id dolor sed, rutrum dapibus metus. Phasellus ullamcorper, libero non vulputate pretium, elit nisi imperdiet ante, nec dapibus leo magna a erat. In hac habitasse platea dictumst. Praesent convallis lacus a dolor interdum, eu varius mauris rhoncus."
                    }
                ],
                "cta": false,
                "divider": false
            }
        ];
    }
})();